/**
 * Static variables collection
 */

/**
 * Sub author type
 */
export const subAuthorType = ['quoted by', 'attributed to', 'referencing letter of', 'referencing speech of']

